import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const MyLinkModal = ({ affiliateId, onClose }) => {
  const [copied, setCopied] = useState(false);
  const referralLink = `musuko.co/a?u=${affiliateId}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const generateQRCode = () => {
    // Simple QR code generation using a service
    return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(referralLink)}`;
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.myLinkModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>
            <FontAwesomeIcon icon="link" />
            <h3>Your Referral Link</h3>
          </div>
          <button className={styles.modalCloseBtn} onClick={onClose}>
            <FontAwesomeIcon icon="times" />
          </button>
        </div>
        
        <div className={styles.modalContent}>
          <div className={styles.linkSection}>
            <h4>
              <FontAwesomeIcon icon="share" style={{ marginRight: '8px' }} />
              Share Your Link
            </h4>
            <p>Share this link with potential clients to earn commissions on their purchases.</p>
            
            <div className={styles.linkContainer}>
              <div className={styles.linkInput}>
                <input
                  type="text"
                  value={referralLink}
                  readOnly
                  className={styles.linkField}
                />
                <button 
                  className={`${styles.copyBtn} ${copied ? styles.copied : ''}`}
                  onClick={copyToClipboard}
                >
                  <FontAwesomeIcon icon={copied ? "check" : "copy"} />
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>
          </div>
          
          <div className={styles.qrSection}>
            <h4>
              <FontAwesomeIcon icon="qrcode" style={{ marginRight: '8px' }} />
              QR Code
            </h4>
            <p>Scan this QR code to access your referral link on mobile devices.</p>
            
            <div className={styles.qrContainer}>
              <img 
                src={generateQRCode()} 
                alt="QR Code for referral link"
                className={styles.qrCode}
              />
              <div className={styles.qrInfo}>
                <span className={styles.qrText}>
                  <FontAwesomeIcon icon="mobile-alt" style={{ marginRight: '6px' }} />
                  Scan to share
                </span>
              </div>
            </div>
          </div>
          
          <div className={styles.commissionInfo}>
            <h4>
              <FontAwesomeIcon icon="gift" style={{ marginRight: '8px' }} />
              Commission Structure
            </h4>
            <div className={styles.commissionCards}>
              <div className={styles.commissionCard}>
                <div className={styles.commissionCardIcon}>
                  <FontAwesomeIcon icon="percentage" />
                </div>
                <div className={styles.commissionCardContent}>
                  <h5>Base Commission</h5>
                  <p>4% on all purchases</p>
                </div>
              </div>
              <div className={styles.commissionCard}>
                <div className={styles.commissionCardIcon}>
                  <FontAwesomeIcon icon="calendar" />
                </div>
                <div className={styles.commissionCardContent}>
                  <h5>Monthly Stipend</h5>
                  <p>$100 bonus</p>
                </div>
              </div>
              <div className={styles.commissionCard}>
                <div className={styles.commissionCardIcon}>
                  <FontAwesomeIcon icon="clock" />
                </div>
                <div className={styles.commissionCardContent}>
                  <h5>Payout Schedule</h5>
                  <p>Monthly on the 1st</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyLinkModal; 